var map = {
	"./dhl_icon.svg": "9327",
	"./fedex_icon.svg": "7b2d",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./package-variant-plus.svg": "e939",
	"./ups_icon.svg": "4533"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";